module.exports = __webpack_public_path__ + "img/logo1.fef1b70e.png";